import { render } from "./ScrollCenterDialog.vue?vue&type=template&id=2353cd83&scoped=true"
import script from "./ScrollCenterDialog.vue?vue&type=script&lang=js"
export * from "./ScrollCenterDialog.vue?vue&type=script&lang=js"

import "./ScrollCenterDialog.vue?vue&type=style&index=0&id=2353cd83&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2353cd83"]])

export default __exports__